// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Eo-z","imageAndVideoCount":"Fo-z","imageAndVideoContainer":"Go-z","viewAllReviews":"Ho-z"};